<div class="bottom cc-bottom">
    <div class="bottom-container">
      <div class="bottom-utils">
        <div class="bottom-language-wrapper" [class.isOpen]="isOpenLanguages">
          @if (languageService.language$ | async; as currentLanguage) {
            <button 
              type="button" 
              class="bottom-language-button button ghost" 
              (click)="languagePickerOpen()"
            >
              <ui-inline-svg name="language" class="icon"></ui-inline-svg>
              {{ 'LANGUAGES.' + currentLanguage.toUpperCase() | transloco }}
            </button>
            <ul class="bottom-language-list">
              @for (language of avalibleLanguages; track language) {
                <li class="bottom-language-list-item" (click)="onChangeLanguage(language)">
                  {{ 'LANGUAGES.' + language.toUpperCase() | transloco }}
                </li>
              }
            </ul>
          }
        </div>
        <a class="bottom-link" [routerLink]="['./help']">
          <button 
            type="button" 
            class="button ghost" 
          >
            <ui-inline-svg name="help" class="icon"></ui-inline-svg>
            {{ 'BOTTOM.HELP' | transloco }}
          </button>
        </a>
      </div>
      <div class="bottom-actions">
        @if (isHome) {
          <button 
            type="button" 
            class="button ghost"
            [routerLink]="['/home/trash']"
          >
            <ui-inline-svg name="delete" class="icon"></ui-inline-svg>
            {{ 'BOTTOM.TRASH' | transloco }}
          </button>
          <button 
            type="button" 
            class="button ghost" 
            (click)="onNewContractModel()"
          >
            <ui-inline-svg name="more" class="icon"></ui-inline-svg>
            {{ 'BOTTOM.NEW' | transloco }}
          </button>
        } @else {
          <button 
            type="button" 
            class="button ghost" 
            (click)="onBack()"
          >
            <ui-inline-svg name="arrow-back" class="icon"></ui-inline-svg>
            {{ 'COMMON.BACK' | transloco }}
          </button>
        }
      </div>
    </div>
  </div>
  